var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthicons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7174 10.6771V8.85419H12.7591V10.6771H14.582V11.7188H12.7591V13.5417H11.7174V11.7188H9.89453V10.6771H11.7174Z",
    fill: "#721372"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.67474 16.3938C3.65494 16.3126 3.64498 16.2294 3.64506 16.1458V6.25001C3.64506 5.97374 3.7548 5.70879 3.95015 5.51344C4.1455 5.31809 4.41045 5.20834 4.68672 5.20834H20.3117C20.588 5.20834 20.8529 5.31809 21.0483 5.51344C21.2436 5.70879 21.3534 5.97374 21.3534 6.25001V16.1458C21.3534 16.2729 21.3305 16.3943 21.2893 16.5068L22.9096 18.9859C22.961 19.0645 22.9901 19.1555 22.994 19.2493C22.9979 19.3431 22.9764 19.4361 22.9317 19.5187C22.8871 19.6012 22.8209 19.6702 22.7403 19.7182C22.6597 19.7663 22.5676 19.7917 22.4737 19.7917H2.49922C2.40637 19.7917 2.3152 19.7668 2.23518 19.7197C2.15515 19.6726 2.08917 19.605 2.04407 19.5238C1.99897 19.4426 1.97639 19.3509 1.97867 19.2581C1.98095 19.1652 2.00801 19.0747 2.05703 18.9958L3.67474 16.3938ZM4.68672 6.25001H20.3117V16.1458H4.68672V6.25001Z",
    fill: "#721372"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthicons);
export default __webpack_public_path__ + "static/media/healthicons.56ced0644f82378d50343207b7c28d15.svg";
export { ForwardRef as ReactComponent };